"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrTravelDatesMobile = exports.FdrTravelDatesDesktop = exports.FdrTravelDates = void 0;
const isBefore_1 = __importDefault(require("date-fns/isBefore"));
const isSameDay_1 = __importDefault(require("date-fns/isSameDay"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const use_deep_compare_effect_1 = __importDefault(require("use-deep-compare-effect"));
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const libs_context_ios_scroll_block_1 = require("@hotelplan/libs.context.ios-scroll-block");
const libs_utils_1 = require("@hotelplan/libs.utils");
const fdr_travel_dates_translations_1 = require("./fdr-travel-dates.translations");
const fdr_travel_dates_styles_1 = require("./fdr-travel-dates.styles");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
const useScrollToDepartureDateMonth_1 = require("./useScrollToDepartureDateMonth");
const fdr_apply_button_1 = require("./fdr-apply-button");
const fdr_travel_dates_information_1 = require("./fdr-travel-dates-information");
const fdr_union_date_picker_1 = require("./fdr-union-date-picker");
const fdr_travel_dates_utils_1 = require("./fdr-travel-dates.utils");
const tomorrow = (0, libs_utils_1.getTomorrowsDate)();
function FdrTravelDates({ travelDatesState, initialReturnDate, saveTravelDates, setReturnDate, setDepartureDate, clearDateRange, configuration, customConfiguration, className, children, triggerSaveTravelDates, closeDropdown, footerChildren, icons, applyText, }) {
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const [t, { language }] = (0, next_i18next_1.useTranslation)(['search', 'common', 'forms']);
    const [hoveredDate, setHoveredDate] = (0, react_1.useState)(null);
    const { departureDate, duration, returnDate, searchType } = travelDatesState;
    // Max travel period is MAX_DATE_RANGE_ON_EXACT_SEARCH days on exact search.
    // Further dates are not clickable if returnDate is not selected
    const maxDate = (customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.maxDate)
        ? customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.maxDate
        : (0, fdr_travel_dates_utils_1.calculateMaxDate)(departureDate, returnDate, searchType);
    const minDate = (customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.minDate)
        ? customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.minDate
        : tomorrow;
    const onDayClick = (0, react_1.useCallback)((day, { disabled }) => {
        if (disabled)
            return;
        if (customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.setReturnDateAsDeparture) {
            setDepartureDate(day);
            setReturnDate(day);
            return;
        }
        if (customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.onlyDepartureDate) {
            setDepartureDate(day);
            return;
        }
        if (customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.onlyReturnDate) {
            setReturnDate(day);
            return;
        }
        if (!returnDate) {
            const pickedDayBeforeDepartureDate = (0, isBefore_1.default)(day, departureDate);
            const pickedDayWhichIsEqToDepartureDate = (0, isSameDay_1.default)(day, departureDate);
            if (pickedDayBeforeDepartureDate) {
                setDepartureDate(day);
            }
            else if (!pickedDayWhichIsEqToDepartureDate) {
                setReturnDate(day);
            }
        }
        else {
            clearDateRange(day);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [departureDate, returnDate]);
    const onDayMouseEnter = (0, react_1.useCallback)((day) => {
        if (!returnDate) {
            setHoveredDate(day);
        }
    }, [returnDate]);
    const travelDatesWrapperEl = (0, useScrollToDepartureDateMonth_1.useScrollToDepartureDateMonth)();
    (0, libs_context_ios_scroll_block_1.useScrollElement)(travelDatesWrapperEl, true);
    (0, use_deep_compare_effect_1.default)(() => {
        if (configuration.hasApplyBtn)
            return;
        saveTravelDates(travelDatesState);
    }, [travelDatesState]);
    (0, react_1.useEffect)(() => {
        if (!triggerSaveTravelDates)
            return;
        saveTravelDates && saveTravelDates(travelDatesState);
    }, [triggerSaveTravelDates]);
    // NOTE: it is needed to set initial month at the time when component "mounts"
    const [initialMonth, setInitialMonth] = (0, react_1.useState)(configuration.initialMonth);
    (0, react_1.useEffect)(() => {
        setInitialMonth(initialMonth);
    }, [initialMonth]);
    const weekDaysShortForLanguage = language === 'fr' ? fdr_travel_dates_translations_1.FR_WEEKDAYS_SHORT : fdr_travel_dates_translations_1.DE_WEEKDAYS_SHORT;
    const monthsForLanguage = language === 'fr' ? fdr_travel_dates_translations_1.FR_MONTHS : fdr_travel_dates_translations_1.DE_MONTHS;
    const applyButtonText = applyText ||
        (mobile ? t('forms:applyButton.datesMobile') : t('forms:apply.button'));
    return (react_1.default.createElement(fdr_travel_dates_styles_1.FdrTravelDatesWrapper, { ref: travelDatesWrapperEl, "data-id": "travelDatesWrapper", className: `wrapper ${className}` },
        children,
        react_1.default.createElement(fdr_union_date_picker_1.FdrUnionDatePicker, { unionDatePickerRef: travelDatesWrapperEl, flexible: searchType === supergraph_api_1.FdrTravelPeriodType.Flexible, weekDaysShortForLanguage: weekDaysShortForLanguage, monthsForLanguage: monthsForLanguage, configuration: configuration, departureDate: departureDate, returnDate: returnDate, hoveredDate: hoveredDate, duration: duration, maxDate: maxDate, minDate: minDate, initialMonth: initialMonth, onDayClick: onDayClick, onDayMouseEnter: onDayMouseEnter, icons: icons }),
        (configuration === null || configuration === void 0 ? void 0 : configuration.disableFooter) ? null : (react_1.default.createElement(fdr_travel_dates_styles_1.FdrTravelDatesBottomPanel, { className: "footer" },
            (customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.hideFooterInformation) ? null : (react_1.default.createElement(fdr_travel_dates_information_1.FdrTravelDatesInformation, { returnDate: returnDate, duration: (0, fdr_travel_dates_utils_1.formatDuration)(t, duration), departureDate: departureDate, onlyDates: customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.onlyDatesInfo, onlyDepartureDate: customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.onlyDepartureDate, onlyReturnDate: customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.onlyReturnDate, language: language })),
            footerChildren,
            configuration.hasApplyBtn && (react_1.default.createElement(fdr_apply_button_1.FdrApplyButton, { state: travelDatesState, initialReturnDate: initialReturnDate, saveTravelDates: saveTravelDates, postSaveAction: () => {
                    if (!configuration.closeOnSaveButtonClick)
                        return;
                    closeDropdown && closeDropdown();
                } }, applyButtonText))))));
}
exports.FdrTravelDates = FdrTravelDates;
exports.FdrTravelDatesDesktop = (0, styled_components_1.default)(FdrTravelDates)(({ theme }) => theme.travelDates.travelDatesDesktop, ({ theme }) => ({
    '.DayPicker-Weekdays': theme.travelDates.weekDaysListCss,
}));
exports.FdrTravelDatesMobile = (0, styled_components_1.default)(FdrTravelDates)(({ theme }) => theme.travelDates.travelDatesMobile);
//# sourceMappingURL=fdr-travel-dates.js.map